import axios from 'axios';

const API_URL = 'https://api.needlmusic.ru';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const register = async (data) => {
  try {
    const response = await api.post('/auth/register', {
      email: data.email,
      username: data.username,
      turnstileToken: data.turnstileToken
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      // Если есть ответ от сервера с ошибкой
      return error.response.data;
    }
    // Если ошибка сети или другая ошибка
    return { error: error.message || 'Ошибка сети' };
  }
};

export default api; 